/**
 * Created by charnjeetelectrovese@gmail.com on 12/20/2019.
 */
import { createBrowserHistory } from "history";
export default createBrowserHistory();
